<template>
  <div class="list-card w100">
    <div class="flex flex-between">
      <h3>
        <i v-html="icon" />
        <span>
          {{ title }}
        </span>
      </h3>

      <TagsList :tags="tags"
                :result-id="resultId"
                :column-id="columnId"
                @select="handleTagSelect" />
    </div>

    <div class="card-content">
      <ul class="answer-list">
        <li class="block"
            v-for="(item, index) in list"
            :key="index">
          {{ item.length > 40 ? `${item.substring(0, 40)} ...` : item }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
  import {useStore} from "vuex";
  import TagsList from "@/components/TagsList.vue";

  const props = defineProps({
    title: String,
    list: Array,
    tags: Array,
    icon: String,
    resultId: String,
    columnId: String,
  })

  const { commit } = useStore()

  function handleTagSelect (payload) {
    commit('SET_TAG', {...payload, resultId: props.resultId})
  }
</script>

<style lang="scss">
  .list-card {
    @media only screen and (min-width: 0) {
      i {
        transform: translateY(2px);
      }
    }
  }
</style>